export const Images = {
  DEFAULT: 'https://ad.hnhuaxi.cn/unknown.png',
}
